module.exports = __webpack_public_path__ + "static/media/OX_OFR_VL_vert_RGB-225x300.aa4a6ba7.png";